import WasmController from "react-lib/frameworks/WasmController";
// api
import InvoiceItemList from "issara-sdk/apis/InvoiceItemList_apps_BIL";
import InvoiceItemTriggerView from "issara-sdk/apis/InvoiceItemTriggerView_apps_INF";

// Serializer
import InvoiceItemImproveSerializer from "issara-sdk/types/InvoiceItemImproveSerializer_apps_BIL";

export type Props = {

}

export type State = Partial<{
  // Sequence
  TriggerInvoiceitemSequence: Partial<{
    sequenceIndex: "Start" | "Action" | null;
    searchTriggerInvoice: any;
    triggerInvoiceList: any;
    userOptions: any;
    paginatedItems: { items?: any[]; page?: number; pageSize?: number; total?: number };
  }>;

  buttonLoadCheck?: any;
  errorMessage?: any;
  successMessage?: any;
}>;

export const StateInitial: State = {
  // Sequence
  TriggerInvoiceitemSequence: {
    sequenceIndex: null,
  },
  // SnackMessage
  errorMessage: null,
  successMessage: null,
};

export type Event = { message: "RunSequence"; params: {} };

export type Data = {
  division?: number;
};

export type TableHeaderType<T> = {
  Header: string;
  accessor: keyof T;
  width?: number;
};

export type AccessorType = Partial<Record<keyof InvoiceItemImproveSerializer, string>>;

export type WidthsType = Partial<Record<keyof InvoiceItemImproveSerializer, number>>;

const Masters = [
  ["billMode", {}],
  ["division", {}],
] as const;

export const LIST_LIMIT = 20;

const PAGINATED_INIT = {
  items: [],
  page: 0,
  total: 0,
  pageSize: LIST_LIMIT,
};

export const statusInvoice = [
  { key: 1, value: "BILLED", text: "รอชำระเงิน" },
  { key: 2, value: "PAID", text: "ชำระเงินแล้ว" },
  { key: 3, value: "CANCELED", text: "ยกเลิกแล้ว" },
  { key: 4, value: "REPLACED", text: "ออกแทนรายการเดิม" },
  { key: 5, value: "ADJUSTED", text: "ถูกปรับปรุงแล้ว" },
  { key: 6, value: "PARTIAL_PAID", text: "ชำระเงินบางส่วน" },
];

export const typeInvoice = [
  { key: 1, value: "PAYMENT", text: "ใบแจ้งหนี้" },
  { key: 2, value: "PLEDGE", text: "มัดจำ" },
  { key: 3, value: "DEPOSIT", text: "ฝากเงิน" },
  { key: 4, value: "REPLACE", text: "ใบเสร็จแทน" },
];

export const stagingStatus = [
  { key: 1, value: 1, text: "NONE" },
  { key: 2, value: 2, text: "ADD" },
  { key: 3, value: 3, text: "UPDATE" },
  { key: 4, value: 4, text: "CANCEL" },
];

export const claimResult = [
  { key: 1, value: 1, text: "เบิกได้" },
  { key: 2, value: 2, text: "เบิกไม่ได้ เนื่องจากตอบคำถามไม่ครบ" },
  { key: 3, value: 3, text: "เบิกไม่ได้ เนื่องจากตอบคำถามไม่ตรงตามเงื่อนไข" },
  { key: 4, value: 4, text: "เบิกไม่ได้ เนื่องจากประเภทรายการสั่งหรือตัวผลิตภัณฑ์ไม่ตรงเงื่อนไข" },
];

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;
/* ------------------------------------------------------ */
/*                          START                         */
/* ------------------------------------------------------ */
export const Start: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.handleEvent({
    message: "GetMasterData",
    params: {
      masters: Masters,
    },
  } as any);

  controller.setState(
    {
      TriggerInvoiceitemSequence: {
        ...state.TriggerInvoiceitemSequence,
        sequenceIndex: "Action",
        paginatedItems: { pageSize: LIST_LIMIT, page: 0 },
      },
    }
    // () => Action(controller, { action: "search" })
  );
};

/* ------------------------------------------------------ */
/*                         ACTION                         */
/* ------------------------------------------------------ */
export const Action: Handler = async (controller, params) => {
  if (params.action === "search") {
    HandleSearchData(controller, params);
  } else if (params.action === "clear") {
    HandleClearData(controller, params);
  } else if (params.action === "save") {
    HandleSaveData(controller, params);
  }
};

const HandleSearchData: Handler = async (controller, params) => {
  const state = controller.getState();
  const searchTriggerInvoice = state.TriggerInvoiceitemSequence?.searchTriggerInvoice;
  const paginatedItems = state.TriggerInvoiceitemSequence?.paginatedItems;

  const page = (params?.page ?? paginatedItems?.page) || 0;
  const pageSize = (params?.pageSize ?? paginatedItems?.pageSize) || LIST_LIMIT;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${params.cardKey}_search`]: "LOADING",
    },
  });

  const offset = page * pageSize;

  // * issue 75103
  if (!searchTriggerInvoice?.hn) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_search`]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [params.cardKey]: "กรุณาระบุ HN ก่อนทำรายการ",
      },
    });

    return;
  }

  let data = {
    limit: pageSize,
    offset,
    hn: searchTriggerInvoice?.hn,
    status: searchTriggerInvoice?.status,
    type: searchTriggerInvoice?.type,
    bill_mode: searchTriggerInvoice?.billMode,
    display_all_data: true,
  };

  const [TriggerInvoiceListRes, TriggerInvoiceListErr, TriggerInvoiceListNet] =
    await InvoiceItemList.list({
      apiToken: controller.apiToken,
      params: data,
    });

  if (TriggerInvoiceListRes) {
    controller.setState({
      TriggerInvoiceitemSequence: {
        ...state.TriggerInvoiceitemSequence,
        triggerInvoiceList: TriggerInvoiceListRes?.items,
        paginatedItems: {
          ...paginatedItems,
          page,
          pageSize,
          total: TriggerInvoiceListRes?.total,
        },
      },
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_search`]: "SUCCESS",
      },
    });
  } else {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_search`]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [params.cardKey]: TriggerInvoiceListErr,
      },
    });
  }
};

const HandleClearData: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    TriggerInvoiceitemSequence: {
      ...state.TriggerInvoiceitemSequence,
      searchTriggerInvoice: {
        hn: "",
        status: "",
        type: "",
        billMode: "",
      },
      triggerInvoiceList: [],
      paginatedItems: {
        ...PAGINATED_INIT,
      },
    },
  });
};

const HandleSaveData: Handler = async (controller, params) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${params.cardKey}_${params.action}`]: "LOADING",
    },
  });

  const [invoiceTriggerRes, invoiceTriggerErr, invoiceTriggerNet] =
    await InvoiceItemTriggerView.put({
      apiToken: controller.apiToken,
      data: {
        invoice_items: params?.selectedItem || [],
      },
    });

  if (invoiceTriggerRes) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.type}`]: "SUCCESS",
      },
      successMessage: {
        ...state.successMessage,
        [params.cardKey]: "The system has successfully",
      },
    });

    HandleSearchData(controller, params);
  } else {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [`${params.cardKey}_${params.type}`]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [params.cardKey]: invoiceTriggerErr,
      },
    });
  }
};

/* ------------------------------------------------------ */
/*                         UTILS                          */
/* ------------------------------------------------------ */

export const accessorList: Partial<Record<keyof InvoiceItemImproveSerializer, string>> = {
  id: "ID",
  type: "Type",
  order_type: "Order Type",
  order_id: "Order ID",
  invoice: "Invoice",
  encounter: "Encounter",
  display_name: "Display Name",
  pricing_name: "Pricing Name",
  pricing_code: "Pricing Code",
  pricing_quantity: "Pricing Quantity",
  pricing_unit: "Pricing Unit",
  division: "Division",
  bill_mode: "Bill Mode",
  cashonly: "Cash Only",
  unitprice: "Unit Price",
  price: "Price",
  claimable: "Claimable",
  send_claim: "Send Claim",
  patient_claim: "Patient Claim",
  non_claimable: "Non Claimable",
  discount: "Discount",
  absorb: "Absorb",
  absorbable: "Absorbable",
  reimbursable: "Reimbursable",
  drg_discount_amount: "Drg Discount Amount",
  paid: "Paid",
  payable: "Payable",
  pay: "Pay",
  status: "Status",
  staging_sequence: "Staging Sequence",
  claim_result: "Claim Result",
  edit_user: "Edit User ID",
  created: "Created",
  edited: "Edited",
  performed: "Performed",
  staging_status: "Staging Status",
  mode_name: "Mode Name",
  mode_code: "Mode Code",
  code: "Code",
  product: "Product",
  quantity: "Qty",
  payment_ready: "Payment Ready",
  status_name: "Status Name",
  discount_code: "Discount Code",
  package_status: "Package Status",
  p_type_code: "P Type Code",
  encounter_doctor: "Encounter Doctor",
  episode_doctor: "Episode Doctor",
  encounter_number: "Encounter Number",
  locker_general_status: "Locker General Status",
};

export const GenerateTableHeader = (
  columnnWidths?: WidthsType
): TableHeaderType<InvoiceItemImproveSerializer>[] => {
  return (Object.entries(accessorList) as [keyof InvoiceItemImproveSerializer, string][]).map(
    ([key, label]) => ({
      Header: label,
      accessor: key,
      ...(columnnWidths && columnnWidths[key] ? { width: columnnWidths[key] } : {}),
    })
  );
};
